import React, { PureComponent, Fragment } from 'react'
import styled from 'styled-components'
import NavBar from "./navigation/nav-bar"
import { Link } from 'react-router-dom'
import Button from './ui/button'
import NavProgressReports from './navigation/nav-progress-reports'
import NavMainAftergameLinks from './navigation/nav-main-aftergame-links'
import ProgressReportsPageHero from './ui/progress-reports-page-hero'
import ParameterFilter from './ui/parameter-filter'
import {
  hasEnoughRespondents,
  getPreviousSurveyId,
  getStatementsProgressResults,
  getDriversProgressResults,
  getThemesProgressResults,
  getResultProgressTotal
} from '../utilities/progress-reports'
import { likertResponseToPercentage } from '../utilities/statistics'
import { formPagePath } from '../utilities/route'
import DashBoardIconVai from '../images/dashboard-icon-vai.svg'
import DashBoardIconThemes from '../images/dashboard-icon-themes.svg'
import DashBoardIconDrivers from '../images/dashboard-icon-drivers.svg'
import DashBoardIconStatements from '../images/dashboard-icon-statements.svg'
import DashBoardIconEngagement from '../images/dashboard-icon-engagement.svg'
import EngagementStats from './progress-reports/engagement-stats'
import DriverStatBar from './ui/driver-stat-bar'
import ProgressIndicator from './progress-reports/progress-indicator'
import TableColumnLabel from './ui/table-column-label'
import { PHONELG, TABLET } from '../utilities/breakpoints'
import DriverProgressCard from './progress-reports/driver-progress-card'
import { findIndex } from 'lodash-es'
import StatementProgressCard from './progress-reports/statement-progress-card'
import { getThemeStyle } from '../utilities/helpers'
import { sortingService } from '../utilities/sortingService'

class ProgressReportsOverview extends PureComponent {

  handleFiltersChange = value => {
    this.props.onSetPrFilters(value);
  }

  render() {
    const {
      respondentParameters,
      match: {
        params: { surveyId, languageCode },
      },
      questionnaire,
      questionnaire: {
        canViewAfterGame,
        logo,
        isFinished,
        isAfterGameGuest,
        isDialogueActive,
        catalysts,
        surveySequence
      },
      currentEngagement,
      previousEngagement,
      currentSurveyStatistics,
      previousSurveyStatistics,
      useTranslate,
      prFilters,
      improvementProject,
    } = this.props;

    const previousSurveyId = getPreviousSurveyId(surveySequence, surveyId);

    const currentVai = hasEnoughRespondents(currentSurveyStatistics)
      ? likertResponseToPercentage(currentSurveyStatistics.overallAggregatedResponse)
      : null;
    const previousVai = hasEnoughRespondents(previousSurveyStatistics)
      ? likertResponseToPercentage(previousSurveyStatistics.overallAggregatedResponse)
      : null;
    const themeProgressResults = getThemesProgressResults(
      currentSurveyStatistics, previousSurveyStatistics, questionnaire, surveyId, previousSurveyId
    );
    const driverProgressResults = getDriversProgressResults(
      currentSurveyStatistics, previousSurveyStatistics, questionnaire, surveyId, previousSurveyId
    );
    const statementProgressResults = getStatementsProgressResults(
      currentSurveyStatistics, previousSurveyStatistics, questionnaire, surveyId, previousSurveyId
    );

    const driversTop5 = [...driverProgressResults].sort(sortingService.byResultProgress(false)).slice(0, 5);
    const driversBottom5 = [...driverProgressResults].sort(sortingService.byResultProgress(true)).slice(0, 5);
    const statementsTop5 = [...statementProgressResults].sort(sortingService.byResultProgress(false)).slice(0, 5);
    const statementsBottom5 = [...statementProgressResults].sort(sortingService.byResultProgress(true)).slice(0, 5);

    // Check if we have enough respondents
    const enoughRespondents = hasEnoughRespondents(currentSurveyStatistics) ||
      hasEnoughRespondents(previousSurveyStatistics);

    const canShowVaiProgress = currentVai !== null && previousVai !== null;

    return (
      <section className="finish-page">
        <ProgressReportsPageHero>
          <div className="aftergame-page-container">
            <NavBar
              to={isFinished && !canViewAfterGame && formPagePath(languageCode, surveyId, 'finish', 'themes')}
              afterGame
              logo={logo}
              canViewAfterGame={canViewAfterGame}
              isAfterGameGuest={isAfterGameGuest}
            >
              {(canViewAfterGame || isAfterGameGuest) &&
                <NavMainAftergameLinks
                  activePage={"progress"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  isDialogueActive={isDialogueActive}
                  showProgressReports={true}
                  improvementProject={improvementProject}
                />
              }
            </NavBar>
          </div>
          <div className="aftergame-page-container">
            <div className="finish-page__intro">
              <h1>{useTranslate("progress_reports.progress_page_title")}</h1>
              <div className="stats-description">
                <p>{useTranslate("progress_reports.progress_page_description")}</p>
              </div>
              <div className="finish-page__intro__nav-holder">
                <NavProgressReports
                  activePage={"overview"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  questionnaire={questionnaire}
                />
              </div>
            </div>
          </div>
        </ProgressReportsPageHero>

        <div className="aftergame-page-container statistics-page-content finish-page__stats pb-5">
          <EngagementStatsCard className="card overview-card">
            <div className="overview-card-header">
              <img src={DashBoardIconEngagement} className="section-icon" alt="icon"/>
              <div>
                <h2>{useTranslate("progress_reports.pr_section_engagement_title")}</h2>
                <p style={{maxWidth: "95%"}}>{useTranslate("progress_reports.pr_section_engagement_description")}</p>
              </div>
            </div>
            <EngagementStats
              current={currentEngagement}
              previous={previousEngagement}
              useTranslate={useTranslate}
            />
          </EngagementStatsCard>

          <div className="finish-page__filters">
            {respondentParameters.length > 0  && (
              <ParameterFilter
                filters={prFilters}
                handleFiltersChange={this.handleFiltersChange}
                respondentParameters={respondentParameters}
                isAfterGameGuest={isAfterGameGuest}
                useTranslate={useTranslate}
              />
            )}
          </div>

          <div className="card overview-card">
            <div className="overview-card-header">
              <img src={DashBoardIconVai} className="section-icon" alt="icon"/>
              <div>
                <h2>{useTranslate("progress_reports.pr_section_vai_title")}</h2>
                <p style={{maxWidth: "95%"}}>{useTranslate("progress_reports.pr_section_vai_description")}</p>
              </div>
            </div>
            {enoughRespondents ?
              <VaiResultsRow>
                <div>
                  <TableColumnLabel>{useTranslate("progress_reports.label_progress")}</TableColumnLabel>
                  <ProgressIndicator
                    resultProgress={canShowVaiProgress ? currentVai - previousVai : null}
                    size={"lg"}
                    showRating={false}
                  />
                </div>
                <div>
                  <TableColumnLabel>{useTranslate("progress_reports.label_latest")}</TableColumnLabel>
                  <DriverStatBar
                    result={currentVai}
                    useTranslate={useTranslate}
                  />
                </div>
                <div>
                  <TableColumnLabel>{useTranslate("progress_reports.label_previous")}</TableColumnLabel>
                  <DriverStatBar
                    result={previousVai}
                    useTranslate={useTranslate}
                    style={{opacity: "0.6"}}
                  />
                </div>
              </VaiResultsRow>
              :
              <p className="no-results">{useTranslate("progress_reports.no_progress_reports_for_parameter")}</p>
            }
          </div>

          <div className="card overview-card">
            <div className="overview-card-header">
              <img src={DashBoardIconThemes} className="section-icon" alt="icon"/>
              <div>
                <h2>{useTranslate("progress_reports.pr_section_themes_title")}</h2>
                <p>{useTranslate("progress_reports.pr_section_themes_description")}</p>
              </div>
            </div>
            {enoughRespondents ?
              <Fragment>
                <ThemeStatsLabels>
                  <ThemeStatsColumns>
                    <TableColumnLabel>{useTranslate("data_vault.label_theme")}</TableColumnLabel>
                    <TableColumnLabel>{useTranslate("progress_reports.label_progress")}</TableColumnLabel>
                    <TableColumnLabel>{useTranslate("progress_reports.label_latest")}</TableColumnLabel>
                    <TableColumnLabel>{useTranslate("progress_reports.label_previous")}</TableColumnLabel>
                  </ThemeStatsColumns>
                </ThemeStatsLabels>
                {themeProgressResults.map((theme, index) => {
                  return (
                    <ThemeResultsRow key={index}>
                      <ThemeStatsColumns>
                        <div className="col">
                          <h5>{theme.title}</h5>
                        </div>
                        <div className="col">
                          <TableColumnLabel>{useTranslate("progress_reports.label_progress")}</TableColumnLabel>
                          <ProgressIndicator
                            resultProgress={theme.resultProgressSincePrevious}
                            size={"md"}
                            showRating={false}
                          />
                        </div>
                        <div className="col">
                          <TableColumnLabel>{useTranslate("progress_reports.label_latest")}</TableColumnLabel>
                          <DriverStatBar
                            result={theme.results[0].result ? theme.results[0].result : null}
                            useTranslate={useTranslate}
                            barColor={getThemeStyle(index).bgColor}
                          />
                        </div>
                        <div className="col">
                          <TableColumnLabel>{useTranslate("progress_reports.label_previous")}</TableColumnLabel>
                          <DriverStatBar
                            result={theme.results[1].result ? theme.results[1].result : null}
                            useTranslate={useTranslate}
                            barColor={getThemeStyle(index).bgColor}
                            style={{opacity: "0.6"}}
                          />
                        </div>
                      </ThemeStatsColumns>
                    </ThemeResultsRow>
                  )
                })}
                <Button
                  as={Link}
                  to={formPagePath(languageCode, surveyId, 'finish', 'progress-reports', 'themes')}
                  className={"more-details-btn"}
                  size={"sm"}
                  kind={"gray"}
                  addArrow={true}
                >
                  {useTranslate("data_vault.more_details")}
                </Button>
              </Fragment>
              :
              <p className="no-results">{useTranslate("progress_reports.no_progress_reports_for_parameter")}</p>
            }
          </div>

          <div className="card overview-card">
            <div className="overview-card-header">
              <img src={DashBoardIconDrivers} className="section-icon" alt="icon"/>
              <div>
                <h2>{useTranslate("progress_reports.pr_section_drivers_title")}</h2>
                <p>{useTranslate("progress_reports.pr_section_drivers_description")}</p>
              </div>
            </div>
            {enoughRespondents ?
              <Fragment>
                <TopBottomContainer>
                  <h3>{useTranslate("progress_reports.top_5_drivers_by_progress")}</h3>
                  {getResultProgressTotal(driversTop5) > 0 ?
                    <div className={"mb-5"}>
                      {driversTop5.map((driver, index) => {
                        return (
                          <DriverProgressCard
                            key={index}
                            index={index}
                            driver={driver}
                            themeIndex={findIndex(catalysts, (c) => c.title === driver.catalystTitle)}
                            showNumbers={true}
                            useTranslate={useTranslate}
                            showLabels={index < 1}
                            showPrevious={false}
                            progressSize={"sm"}
                          />
                        )
                      })}
                    </div>
                    :
                    <p className="no-results mb-5">{useTranslate("progress_reports.unable_to_get_top_or_bottom")}</p>
                  }
                  <h3>{useTranslate("progress_reports.bottom_5_drivers_by_progress")}</h3>

                  {getResultProgressTotal(driversBottom5) > 0 ?
                    <div>
                      {driversBottom5.map((driver, index) => {
                        return (
                          <DriverProgressCard
                            key={index}
                            index={index}
                            driver={driver}
                            themeIndex={findIndex(catalysts, (c) => c.title === driver.catalystTitle)}
                            showNumbers={true}
                            useTranslate={useTranslate}
                            showLabels={index < 1}
                            showPrevious={false}
                            progressSize={"sm"}
                          />
                        )
                      })}
                    </div>
                    :
                    <p className="no-results mb-0">{useTranslate("progress_reports.unable_to_get_top_or_bottom")}</p>
                  }
                </TopBottomContainer>
                <Button
                  as={Link}
                  to={formPagePath(languageCode, surveyId, 'finish', 'progress-reports', 'drivers')}
                  className={"more-details-btn"}
                  size={"sm"}
                  kind={"gray"}
                  addArrow={true}
                >
                  {useTranslate("data_vault.more_details")}
                </Button>
              </Fragment>
              :
              <p className="no-results">{useTranslate("progress_reports.no_progress_reports_for_parameter")}</p>
            }
          </div>

          <div className="card overview-card mb-5">
            <div className="overview-card-header">
              <img src={DashBoardIconStatements} className="section-icon" alt="icon"/>
              <div>
                <h2>{useTranslate("progress_reports.pr_section_statements_title")}</h2>
                <p>{useTranslate("progress_reports.pr_section_statements_description")}</p>
              </div>
            </div>
            {enoughRespondents ?
              <Fragment>
                <TopBottomContainer>
                  <h3>{useTranslate("progress_reports.top_5_statements_by_progress")}</h3>
                  {getResultProgressTotal(statementsTop5) > 0 ?
                    <div className={"mb-5"}>
                      {statementsTop5.map((statement, index) => {
                        return (
                          <StatementProgressCard
                            key={index}
                            index={index}
                            statement={statement}
                            themeIndex={findIndex(catalysts, (c) => c.title === statement.catalystTitle)}
                            showNumbers={true}
                            useTranslate={useTranslate}
                            showLabels={index < 1}
                            showPrevious={false}
                          />
                        )
                      })}
                    </div>
                    :
                    <p className="no-results mb-5">{useTranslate("progress_reports.unable_to_get_top_or_bottom")}</p>
                  }
                  <h3>{useTranslate("progress_reports.bottom_5_statements_by_progress")}</h3>
                  {getResultProgressTotal(statementsBottom5) > 0 ?
                    <div>
                      {statementsBottom5.map((statement, index) => {
                        return (
                          <StatementProgressCard
                            key={index}
                            index={index}
                            statement={statement}
                            themeIndex={findIndex(catalysts, (c) => c.title === statement.catalystTitle)}
                            showNumbers={true}
                            useTranslate={useTranslate}
                            showLabels={index < 1}
                            showPrevious={false}
                          />
                        )
                      })}
                    </div>
                    :
                    <p className="no-results mb-5">{useTranslate("progress_reports.unable_to_get_top_or_bottom")}</p>
                  }
                </TopBottomContainer>
                <Button
                  as={Link}
                  to={formPagePath(languageCode, surveyId, 'finish', 'progress-reports', 'statements')}
                  className={"more-details-btn"}
                  size={"sm"}
                  kind={"gray"}
                  addArrow={true}
                >
                  {useTranslate("data_vault.more_details")}
                </Button>
              </Fragment>
              :
              <p className="no-results">{useTranslate("progress_reports.no_progress_reports_for_parameter")}</p>
            }
          </div>

        </div>
      </section>
    );
  }
}

export default ProgressReportsOverview;

const EngagementStatsCard = styled.div`
  margin-bottom: 3rem;
`;

const VaiResultsRow = styled.div`

  > div {
    margin-bottom: 10px;
  }
  
  .table-column-label {
    margin-bottom: 8px;
  }
  
  @media${PHONELG} {
    display: grid;
    grid-template-columns: 100px 1fr 1fr;
    grid-column-gap: 10px;
    
    .result-indicator {
      margin-top: 8px;
    }
  }
  
  @media${TABLET} {
    grid-column-gap: 30px;
  }
`;

const ThemeStatsColumns = styled.div`
  
  .table-column-label {
    margin-bottom: 8px;
  }
  
  @media${PHONELG} {
    display: grid;
    grid-template-columns: 3fr 75px 2fr 2fr;
    grid-column-gap: 10px;
    align-items: center;
  }
  
  @media${TABLET} {
    grid-column-gap: 30px;
  }
`;

const ThemeStatsLabels = styled.div`
  display: none;
  
  @media${PHONELG} {
    display: block;
  }
`;

const ThemeResultsRow = styled.div`
  padding-bottom: 15px;
  
  & + & {
    border-top: 1px solid #d9d9d9;
    padding-top: 15px;
  }
  
  &:first-of-type {
    padding-top: 0;
  }
  
  h5 {
    margin: 0;
  }
  
  .col {
    padding: 0;
    margin-bottom: 10px;
  }
  
  @media${PHONELG} {
    .table-column-label {
      display: none;
    }
    
    .col {
      margin-bottom: 0;
    }
  }
`;

const TopBottomContainer = styled.div`
  h3 {
    margin-bottom: 1.5rem;
  }
`;



// WEBPACK FOOTER //
// ./src/components/progress-reports-overview.js